/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForTclItsm extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForTclItsm");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForTclItsm.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForTclItsm>): ServiceAccountNativeDetailsForTclItsm {
        let obj = Object.assign(new ServiceAccountNativeDetailsForTclItsm(), model);
        ServiceAccountNativeDetailsForTclItsm.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForTclItsm>): ServiceAccountNativeDetailsForTclItsm {
        if (!model) return null;
        return ServiceAccountNativeDetailsForTclItsm.newInstance(<ServiceAccountNativeDetailsForTclItsm> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForTclItsm) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForTclItsm.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForTclItsm): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForTclItsm.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.product_activation) {
            for (let val of this.product_activation) {
                models.IntegratedToolProductActivation.fixupPrototype(val);
            }
        }
    }

    product_activation: Array<models.IntegratedToolProductActivation>;

}
